<template>
<!-- Screenshots Section Start -->
<section id="carouselshot" class="screenshot p-2">
    <div class="screenshot-decor">
        <div class="screenshot-circle1"><img :src='"../assets/images/feature-circle-two.png"' alt="feature-circle-two"></div>
        <div class="screenshot-circle2"><img :src='"../assets/images/feature-circle.png"' alt="feature-circle"></div>
        <div class="screenshot-circle3"><img :src='"../assets/images/main-banner1.png"' alt="feature-circle-three"></div>
    </div>
    <div class="container-fuid">
        <div class="row">
            <div class="col-sm-12 ">
                <h2 class="title text-center">Notre plaquette</h2>
                <div class="screenshot-contain pb-3">
                    <swiper ref="yrSwiper" :options="swiperOptions">
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-1.jpg" alt="app"></div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-2.jpg" alt="app"></div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-3.jpg" alt="app"></div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-4.jpg" alt="app"></div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-5.jpg" alt="app"></div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-6.jpg" alt="app"></div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="text-center"><img class="img-fluid" src="../assets/images/pdf/nume__ro-7.jpg" alt="app"></div>
                        </swiper-slide>
                    </swiper>
                </div>
                 <div class="top-margin text-center mt-4 mb-4">
                <button type="button" class="btn btn-custom my-theme-color my-theme-color"><a href="static/ctp.pdf" style="color:white;" target="_blank">Téléchargez notre plaquette </a></button>
            </div>
            </div>
            
        </div>
    </div>
</section>
<!-- Screenshots Section End -->
</template>

<script>
export default {
    name: 'Carouselpdf',
    data() {
        return {
            swiperOptions: {
                slidesPerView: 1,
                spaceBetween: 10,
                grabCursor: true,
                loop: true,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: false
                },
                breakpoints: {
                    400: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    1600: {
                        slidesPerView: 4,
                        spaceBetween: 50
                    },
                    2100: {
                        slidesPerView: 5,
                        spaceBetween: 60
                    }
                }
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.yrSwiper.$swiper
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Carouselpdf.vue